import { Modal } from 'react-bootstrap';
import { SignInMethod } from '../modules/accounts/components/settings/cards/SignInMethod';


const modalBackdropStyles = `
    .modal-backdrop.show{
      opacity: 0.6; !important;
       
    }
`;



const PasswordUpdate = ({ show, onClose }) => {
    // const [files, setFiles] = useState([]);
    // const [uploadProgress, setUploadProgress] = useState(0);

    // const handleFileChange = (e) => {
    //     const selectedFiles = Array.from(e.target.files);
    //     setFiles(selectedFiles);
    //     setUploadProgress(0);
    // };

    // const handleUpload = () => {
    //     if (!files.length) return;

    //     let progress = 0;
    //     const interval = setInterval(() => {
    //         progress += 10;
    //         if (progress >= 100) {
    //             progress = 100;
    //             clearInterval(interval);
    //         }
    //         setUploadProgress(progress);
    //     }, 200);
    // };

    return (
        <>
            {/* Inject custom CSS for backdrop */}
            <style>{modalBackdropStyles}</style>

            <Modal
                className="modal-xl"
                show={true}
                centered
                backdropClassName="modal-backdrop.show"
                keyboard={false}

            >
                <Modal.Body>
                    <h3 className='fw-bold m-0'>Change Your Password</h3>
                    <div className='separator separator-dashed my-6'></div>
                    <p>Please enter your current password and new password to update your password.</p>
                    <SignInMethod />
                </Modal.Body>
            </Modal>
        </>
    );
};

export { PasswordUpdate };
